export const SupportControllerFactory = ({
  supportService,
}: {
  supportService: ISupportService;
}) => {
  const submitRating: ISubmitRating = async (payload) => {
    const { success, data } = await supportService.submitRatingService({
      comment: payload.comment || "",
      score: payload.rating,
      person_properties: {
        facility: payload.facilityName,
        name: payload.userName,
      },
    });
    if (success) {
      return { success: true, data: data };
    }
    return { success: false, error: { message: "error" } };
  };
  return {
    addReportAProblem: supportService.addReportAProblem,
    submitFeedback: supportService.submitFeedback,
    submitRating,
  };
};
